import { useContext } from 'react'

import { DashboardPermissionsContext } from './DashboardPermissionsProvider'
import type { DashboardPermissions } from './types'

export function useDashboardPermissionsContext() {
  const dashboardPermissions = useContext<DashboardPermissions | undefined>(
    DashboardPermissionsContext,
  )

  if (dashboardPermissions === undefined) {
    throw new Error(
      'useDashboardPermissionsContext must be used within a DashboardPermissionsProvider',
    )
  }

  return { dashboardPermissions }
}
